import AbonementsContainer from './AbonementsContainer';
export default AbonementsContainer;
